import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { AzureBlobStorageService } from '@app/shared/services/api/azure-blob-storage.service';
import { HttpClient } from '@angular/common/http';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';

@Component({
  selector: 'app-design-wizard',
  templateUrl: './design-wizard.component.html',
})
export class DesignWizardComponent implements OnInit {
  cssString: string = '';

  color = {
    primary: '',
    secondary: '',
    tertiary: '',
    accent: '',
  };

  cssFileName = 'variables.css';

  constructor(
    public http: HttpClient,
    private blobStorageService: AzureBlobStorageService,
    public overlayLoaderService: OverlayLoaderService,
  ) {}

  ngOnInit() {
    this.blobStorageService.getVariableCss(`${environment.tenant}/assets/${this.cssFileName}`).subscribe((data) => {
      this.cssString = data;
      this.color.primary = this.getCssValue('--ep-primary-color');
      this.color.secondary = this.getCssValue('--ep-secondary-color');
      this.color.tertiary = this.getCssValue('--ep-tertiary-color');
      this.color.accent = this.getCssValue('--ep-accent-color');
    });
  }

  getCssValue(property: string) {
    const strPropIndex = this.cssString.indexOf(property);
    const strStartIndex = this.cssString.indexOf('#', strPropIndex);
    const strEndIndex = this.cssString.indexOf(';', strStartIndex);
    return this.cssString.substring(strStartIndex, strEndIndex);
  }

  updateCssValue(property: string, value: string) {
    const strPropIndex = this.cssString.indexOf(property);
    const strStartIndex = this.cssString.indexOf('#', strPropIndex);
    const strEndIndex = this.cssString.indexOf(';', strStartIndex);
    this.cssString = this.cssString.replace(this.cssString.substring(strStartIndex, strEndIndex), value);
  }

  updateCss() {
    this.overlayLoaderService.isLoading = true;

    this.updateCssValue('--ep-primary-color', this.color.primary);
    this.updateCssValue('--ep-secondary-color', this.color.secondary);
    this.updateCssValue('--ep-tertiary-color', this.color.tertiary);
    this.updateCssValue('--ep-accent-color', this.color.accent);

    this.blobStorageService.updateVariableCss(`${this.cssFileName}`, this.cssString).subscribe(() => {
      this.overlayLoaderService.isLoading = false;
    });
  }
}
